import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Channel } from '../models/channel.model';
import { ChatMessage } from '../models/chat-message.model';

@Injectable({ providedIn: 'root' })
export class ChatStore {

  private readonly _channels$       = new BehaviorSubject<Channel[]>([]);
  private readonly _activeChannel$  = new BehaviorSubject<Channel | null>(null);
  private readonly _messages$       = new BehaviorSubject<ChatMessage[]>([]);
  private readonly _loadingChannels$ = new BehaviorSubject<boolean>(false);
  private readonly _loadingMessages$ = new BehaviorSubject<boolean>(false);
  private readonly _sdkReady$       = new BehaviorSubject<boolean>(false);

  readonly channels$:        Observable<Channel[]>      = this._channels$.asObservable();
  readonly activeChannel$:   Observable<Channel | null> = this._activeChannel$.asObservable();
  readonly messages$:        Observable<ChatMessage[]>  = this._messages$.asObservable();
  readonly loadingChannels$: Observable<boolean>        = this._loadingChannels$.asObservable();
  readonly loadingMessages$: Observable<boolean>        = this._loadingMessages$.asObservable();
  readonly sdkReady$:        Observable<boolean>        = this._sdkReady$.asObservable();

  setChannels(channels: Channel[]): void { this._channels$.next(channels); }
  setActiveChannel(channel: Channel | null): void {
    this._activeChannel$.next(channel);
    this._messages$.next([]);
  }
  setMessages(messages: ChatMessage[]): void { this._messages$.next(messages); }
  appendMessage(message: ChatMessage): void  { this._messages$.next([...this._messages$.getValue(), message]); }
  setLoadingChannels(v: boolean): void       { this._loadingChannels$.next(v); }
  setLoadingMessages(v: boolean): void       { this._loadingMessages$.next(v); }
  setSdkReady(v: boolean): void              { this._sdkReady$.next(v); }

  get activeChannel(): Channel | null { return this._activeChannel$.getValue(); }
  get messages(): ChatMessage[]       { return this._messages$.getValue(); }
  get sdkReady(): boolean             { return this._sdkReady$.getValue(); }
}
